// WDCE-199 step 9f: the EFTPOS payment endpoints (EftposPaymentsController), with fetch passed in so tests can check
// exactly what is sent.
//
//   const eftpos = createEftposApi({ fetch: window.fetch.bind(window), csrfToken, orderId })
//   eftpos.start({ eftposTerminalId, processAndPrint }) // POST   /orders/:id/eftpos_payments
//   eftpos.status(paymentId)                           // GET    /orders/:id/eftpos_payments/:payment_id
//   eftpos.lookup()                                    // GET    /orders/:id/eftpos_payments (step 9a)
//   eftpos.sendKey(paymentId, key, data)               // POST   /orders/:id/eftpos_payments/:payment_id/keys
//
// Every request sends the X-CSRF-Token header, credentials and Accept: application/json. Each resolves with what came
// back, in orders/orderResponse.js's shape: { networkError: true }, or { status, json, body } where json says whether
// the body was JSON and body is the parsed JSON. None rejects: what to make of the answer is paymentScreen.js's job.
// Arguments that would send the wrong thing throw at once, sending nothing.

// The longest entry the auth key takes (Linkly::PaymentsClient::MAX_KEY_DATA_LENGTH).
export const MAX_AUTH_LENGTH = 60

const isJson = (response) => {
  const type = response.headers && response.headers.get('Content-Type')
  return typeof type === 'string' && type.includes('application/json')
}

const read = (response) => {
  const status = response.status
  if (!isJson(response)) return { status, json: false }

  return response.json().then((body) => ({ status, json: true, body }), () => ({ status, json: false }))
}

export function createEftposApi({ fetch, csrfToken, orderId }) {
  const base = `/orders/${orderId}/eftpos_payments`

  const request = (method, path, body) => {
    const headers = { Accept: 'application/json', 'X-CSRF-Token': csrfToken }
    const options = { method, credentials: 'include', headers }
    if (body !== undefined) {
      headers['Content-Type'] = 'application/json'
      options.body = JSON.stringify(body)
    }

    let answer
    try {
      answer = Promise.resolve(fetch(path, options))
    } catch (error) {
      answer = Promise.reject(error)
    }
    return answer.then(read, () => ({ networkError: true })).catch(() => ({ networkError: true }))
  }

  return {
    // process_and_print must be a real true or false: the server refuses anything else.
    start({ eftposTerminalId, processAndPrint }) {
      if (typeof processAndPrint !== 'boolean') {
        throw new TypeError(`processAndPrint must be true or false, not ${processAndPrint}`)
      }
      return request('POST', base, { eftpos_terminal_id: eftposTerminalId, process_and_print: processAndPrint })
    },

    status(paymentId) {
      return request('GET', `${base}/${paymentId}`)
    },

    lookup() {
      return request('GET', base)
    },

    sendKey(paymentId, key, data) {
      if (key !== 'auth' && data !== undefined) throw new TypeError('Only the auth key takes data')

      return request('POST', `${base}/${paymentId}/keys`, key === 'auth' ? { key, data } : { key })
    }
  }
}
